import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminGuard from "./components/AdminGuard";

import LandingPage from "./pages/LandingPage";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import LoginPage from "./pages/LoginPage";
import PasswordResetRequest from "./pages/PasswordResetRequest";
import PasswordResetConfirm from "./pages/PasswordResetConfirm";
import DashboardLayout from "./pages/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import PhotoSystem from "./pages/PhotoSystem";
import PromptLibrary from "./pages/PromptLibrary";
import Gallery from "./pages/Gallery";
import Resources from "./pages/Resources";
import BrandProfile from "./pages/BrandProfile";
import Step1Upload from "./pages/Step1Upload";
import Step2Brand from "./pages/Step2Brand";
import Step4Generate from "./pages/Step4Generate";
import Step5Upload from "./pages/Step5Upload";
import AdminLayout from "./pages/AdminLayout";
import AdminOverview from "./pages/AdminOverview";
import AdminUsers from "./pages/AdminUsers";
import AdminResources from "./pages/AdminResources";
import AdminPrompts from "./pages/AdminPrompts";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import CookiePolicy from "./pages/CookiePolicy";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <CookieBanner />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<PasswordResetRequest />} />
            <Route path="/reset-password" element={<PasswordResetConfirm />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route
              path="/admin"
              element={
                <AdminGuard>
                  <AdminLayout />
                </AdminGuard>
              }
            >
              <Route index element={<AdminOverview />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="prompts" element={<AdminPrompts />} />
              <Route path="resources" element={<AdminResources />} />
            </Route>
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="step1" element={<Step1Upload />} />
              <Route path="step2" element={<Step2Brand />} />
              <Route path="step3" element={<PromptLibrary />} />
              <Route path="step4" element={<Step4Generate />} />
              <Route path="step5" element={<Step5Upload />} />
              <Route path="step6" element={<Gallery />} />
              <Route path="system" element={<PhotoSystem />} />
              <Route path="prompts" element={<PromptLibrary />} />
              <Route path="gallery" element={<Gallery />} />
              <Route path="resources" element={<Resources />} />
              <Route path="brand-profile" element={<Step2Brand />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
